<template>
  <div class="wrap">
    <b-form v-on:submit.prevent="submitHandler">
      <b-card header="톡채널 등록">
        <b-form-group
                label="톡채널 ID"
                label-for="plusfriendsId"
                :label-class="labelClasses+` zzz`">
          <b-form-input id="plusfriendsId"
                        v-model="pgmAdDto.plusFriendViewInfo.plusFriendId"
                        value=""
                        class="d-inline-block w-50" placeholder="톡채널 ID를 등록해주세요 ex)262962272" required></b-form-input>
          <b-button type="button" @click="isValid">입력한 톡채널 확인</b-button>
          <p>
            * 톡채널 ID는 TMS 어드민에서 확인 가능합니다.
            <br>
            (<a href="http://admin.tms.kakao.com/profiles" target="_blank">http://admin.tms.kakao.com/profiles</a> - 접속 후 새로운 권한 신청하는 포맷에서 확인  가능 (단 uuid; @게임친구는 알고 있어야함)
          </p>
          <p>
            * 확인버튼을 클릭하면 입력한 톡채널를 확인하실 수 있습니다.
          </p>
        </b-form-group>

        <b-form-group
                label="게임 선택"
                label-for="game"
                :label-class="labelClasses+` zzz`" v-if="status === 'create'">
          <div class="vSelectWrapper">
            <v-select v-model="selectedGame" @input="selectGameHandler" label='name' :options="appList" placeholder="모바일게임 이름을 입력해주세요." required>
              <template slot="no-options">검색 결과가 없습니다.</template>
              <!--<template slot="option" slot-scope="option">-->
              <!--<span :class="option.icon"></span>-->
              <!--{{ option.title }}-->
              <!--</template>-->
            </v-select>
          </div>
          <p>
            * 연결게임의 사전예약 설정시, 설정화면에서 톡채널 노출여부를 설정할 수 있습니다.
          </p>
        </b-form-group>

        <b-form-group
                label="게임 명"
                label-for="appName"
                :label-class="labelClasses+` zzz`" v-else>
          <b-form-input id="appName"
                        v-model="pgmAdDto.appName"
                        value=""
                        class="d-inline-block w-50" readonly required></b-form-input>
        </b-form-group>


        <b-form-group
                label="톡채널 이름 입력"
                label-for="plusfriendsName"
                :label-class="labelClasses+` zzz`">
          <b-form-input id="plusfriendsName"
                        v-model="pgmAdDto.title"
                        value=""
                        class="d-inline-block w-50" placeholder="톡채널 이름을 입력해주세요" required></b-form-input>
          <p>
            * 수정된 내용은 게임하기내 톡채널 추가 영역내에서만 반영됩니다.
          </p>
        </b-form-group>

        <b-form-group
                label="톡채널 추가 혜택 (톡채널 목록내 단문)"
                label-for="rewardShortDesc"
                :label-class="labelClasses+` zzz`" style="position: relative;">
          <b-form-textarea id=""
                           :value="pgmAdDto.plusFriendViewInfo.shortDesc"
                           @input="limitInputByMaxByte($event, pgmAdDto.plusFriendViewInfo, 'shortDesc', 45)"
                           :rows="2"
                           :max-rows="6" placeholder="" required>
          </b-form-textarea>
          <span style="position: absolute; right:0; bottom:0">({{calcCharacterByte(pgmAdDto.plusFriendViewInfo.shortDesc)}}/45bytes)</span>
          <p>
            * 사전예약완료 시 완료화면의 하단에 목록형으로 노출될 때 사용하는 문구입니다.
          </p>
        </b-form-group>

        <b-form-group
                label="톡채널 추가 혜택 (톡채널 추가 팝업내 장문)"
                label-for="rewardLongDesc"
                :label-class="labelClasses+` zzz`" style="position: relative;">
          <b-form-textarea id=""
                           :rows="2"
                           :value="pgmAdDto.plusFriendViewInfo.longDesc"
                           @input="limitInputByMaxByte($event, pgmAdDto.plusFriendViewInfo, 'longDesc', 88)"
                           :max-rows="2" placeholder="" required>
          </b-form-textarea>
          <span style="position: absolute; right:0; bottom:0">({{calcCharacterByte(pgmAdDto.plusFriendViewInfo.longDesc)}}/88bytes)</span>
          <p>
            * 톡채널 추가 팝업에서 사용하는 문구입니다.
          </p>
        </b-form-group>

        <b-form-group
                label="보상 이미지 등록 (보상 있는 경우)"
                label-for="image"
                :label-class="labelClasses+` zzz`">
          <div style="width: 350px;">
            <b-form-radio-group v-model="isUseImage" :options="yesOrNoOption"></b-form-radio-group>
            <div v-show="isUseImage">
              <vue-dropzone ref="img" id="img" :options="Object.assign({}, JSON.parse(JSON.stringify(dropzoneOptions)), {clickable: ['#img', '#imgUploadBtn'], withCredentials: true, maxFilesize: 0.05, renameFile: renameAndSetDtoProperty.bind(this, { obj: pgmAdDto.plusFriendViewInfo, name: 'imgUrl' }), accept: acceptHandlingForDimensionLimit.bind(this, 430, 282, '톡채널 이미지')})"
                            v-on:vdropzone-thumbnail="thumbhnailHandlingForLimtDismension" v-on:vdropzone-success="imgSuccessHandling" v-on:vdropzone-removed-file="imgRemove" v-on:vdropzone-sending="$refs['img'].removeAllFiles(false);" class="mb-2"></vue-dropzone>
              <div>
                <b-button type="button" id="imgUploadBtn">upload</b-button>
                <b-button type="button" :href="pgmAdDto.plusFriendViewInfo.imgUrl" v-if="pgmAdDto.plusFriendViewInfo.imgUrl" class="ml-3" target="_blank">download</b-button>
              </div>
            </div>
          </div>
          <p>* 사이즈: 430 * 282 / 용량은 50KB이하로 등록해주세요.</p>
          <p>* 이미지가 없을 경우 톡채널 기본이미지가 노출됩니다. <a href="//playgame-img.kakaogames.com/production/static/images/plusfriends_default.png" target="_blank">기본이미지보기</a></p>
          <p>* 해당 이미지는 목록과 팝업에서 동일한 이미지가 사이즈만 조정되어 노출됩니다. </p>
        </b-form-group>

        <b-row class="align-items-center mt-3">
          <b-col cols="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
            <b-button block variant="outline-primary" type="submit">{{ statusText[status] }}</b-button>
          </b-col>
          <b-col cols="6" sm="4" m
                 d="2" xl class="mb-3 mb-xl-0">
            <b-button block variant="outline-secondary" v-on:click="$router.go(-1)">뒤로</b-button>
          </b-col>
        </b-row>

      </b-card>
    </b-form>
  </div>
</template>
<script>
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import { labelClasses, IMAGE_UPLOAD_URL } from '@/constants'
  import { mapState, mapMutations } from 'vuex'
  import { MODULE_NAME as APP_MODULE, FETCH_APPS } from '@/store/app/actions.type'
  import { SHOW_MODAL } from '@/store/ui/mutations.type'
  import playGameService from '@/common/api/playGame.service'
  import { $showModalWithErrorMsg, limitInputByMaxByte, calcCharacterByte, thumbhnailHandlingForLimtDismension, renameAndSetDtoProperty, acceptHandlingForDimensionLimit, $imgRemove, $imgSuccessHandling, addProperty, removeProperty } from '@/common/util'
  export default {
    components: {
      vueDropzone: vue2Dropzone
    },
    data () {
      return {
        isUseImage: false,
        yesOrNoOption: [
          {
            value: false, text: '없음'
          },
          {
            value: true, text: '있음'
          }
        ],
        status: 'create',
        statusText: {
          'create': '등록',
          'update': '수정'
        },
        labelClasses: labelClasses,
        limitInputByMaxByte: limitInputByMaxByte,
        selectedGame: null,
        // dropzoneJs 옵션
        dropzoneOptions: {
          withCredentials: true,
          paramName: 'image',
          url: process.env.VUE_APP_BASE_URL + IMAGE_UPLOAD_URL,
          dictDefaultMessage: '파일을 선택해주세요.',
          dictRemoveFile: '삭제',
          thumbnailWidth: 250,
          thumbnailHeight: 250,
          thumbnailMethod: 'contain',
          addRemoveLinks: true,
          // maxFilesize: 0.4,
          dictFileTooBig: '파일 용량을 초과하였습니다. (최대 용량 : {{maxFilesize}}MB)',
          dictMaxFilesExceeded: '{{maxFiles}}개까지 업로드 가능합니다.',
          dictResponseError: '일시적으로 네트워크 오류가 있습니다. 삭제 후, 다시 시도해주세요.',
          acceptedFiles: 'image/gif, image/png, image/jpeg'
        },
        pgmAdDto: {
          seq: 0,
          title: '',
          appMasterId: 0,
          appName: '',
          plusFriendViewInfo: {
            plusFriendId: 0,
            shortDesc: '톡채널 추가하고 최신 소식과 풍성한 혜택을 받아보세요~',
            longDesc: '톡채널을 추가하고 다양한 정보와 추가 혜택을 받아가세요!',
            imgUrl: ''
          }
        },
        isValidPlusFriendId: undefined,
        addProperty: addProperty,
        removeProperty: removeProperty,
        imgRemove: $imgRemove.bind(this),
        imgSuccessHandling: $imgSuccessHandling.bind(this)
      }
    },
    mounted () {
      if (this.$route.name === 'plusFriendEdit') {
        this.status = 'update'
        this.isValidPlusFriendId = true
        playGameService.getPlusFriend(this.$route.query.appMasterId)
          .then((res)=> {
            if (!res.data) {
              this[SHOW_MODAL]({msg: '톡채널을 먼저 등록해주세요.', okHandling: ()=> {
                // 리스트로 이동시키기
                // this.$router.push({name: 'plusFriendNew'})
                this.$router.go(-1)
              }})
              return;
            }
            Object.assign(this.pgmAdDto, res.data)
            Object.assign(this.pgmAdDto.plusFriendViewInfo, res.data.viewInfo)
            if (this.pgmAdDto.plusFriendViewInfo.imgUrl !== '') {
              this.$refs.img.manuallyAddFile({
                pregDtoParam: {
                  lang: '',
                  name: 'imgUrl',
                  uploadUrl: this.pgmAdDto.plusFriendViewInfo.imgUrl,
                  isMultiple: false,
                  obj: this.pgmAdDto.plusFriendViewInfo,
                }}, this.pgmAdDto.plusFriendViewInfo.imgUrl)
            }
            console.log(this.pgmAdDto)
          })
          .catch($showModalWithErrorMsg.bind(this))

      // 플친 등록
      } else {
        this.$store.dispatch(APP_MODULE + FETCH_APPS)
          .then(()=> {
            // getter를 이용하는게 좋긴 하다.
            for(let i=0; i < this.appList.length; i++) {
              this.appList[i].name= this.appList[i].appName['ko']
            }
          })
          .catch($showModalWithErrorMsg.bind(this))
      }
    },
    computed: {
      ...mapState('app', {
          appList: 'list'
        })
    },
    watch: {
      'pgmAdDto.plusFriendViewInfo.imgUrl': {
        handler (newVal, oldVal) {
          if (newVal !== null && newVal !== '') {
            this.isUseImage = true
          }
        },
      },
      isUseImage (newVal, oldVal) {
        console.log(arguments)
        if (newVal === false ) {
          this.pgmAdDto.plusFriendViewInfo.imgUrl =''
          this.$refs.img.removeAllFiles(true)
        }
      }
    },
    methods: {
      imgHandlingTemplate (file, fn) {
        console.log('arguements..' )
        console.log(arguments)
        const objDtoParam = file.pregDtoParam
        if (objDtoParam.lang === '') {
          fn(objDtoParam.obj, objDtoParam.name, objDtoParam.uploadUrl)
        } else {
          fn(this.pgmAdDto.plusFriendViewInfo[objDtoParam.name], objDtoParam.lang,
            {
              order: this.pgmAdDto.plusFriendViewInfo[objDtoParam.name][objDtoParam.lang].length + 1,
              imageUrl: objDtoParam.uploadUrl
            })
          console.log('---imghnadlingaTmeplatge')
          console.log(file)
          console.log(fn)
          console.log('---imghnadlingaTmeplatge')
          // fn(this.preg[objDtoParam.name], objDtoParam.lang, objDtoParam.uploadUrl)
        }
      },
      renameAndSetDtoProperty: renameAndSetDtoProperty,
      thumbhnailHandlingForLimtDismension: thumbhnailHandlingForLimtDismension,
      selectGameHandler (app) {
        this.pgmAdDto.appMasterId = app.appMasterId
        this.pgmAdDto.appName = app.appName.ko || ''
        this.pgmAdDto.title = app.appName.ko || ''
      },
      submitHandler () {
        //플친 수정
        if (this.status === 'update') {
          if (!this.isValidPlusFriendId) {
            this[SHOW_MODAL]({msg: '유효하지 않은 톡채널 아이디입니다.', okHandling: () => {}})
            return;
          }
          if (this.isUseImage && this.pgmAdDto.plusFriendViewInfo.imgUrl === '') {
            this[SHOW_MODAL]({msg: '이미지를 등록하세요.'})
            return;
          }

          playGameService.updatePlusFriend(this.pgmAdDto)
            .then((res)=> {
              this[SHOW_MODAL]({msg: '수정이 완료되었습니다.', okHandling: () => {this.$router.push({name: 'plusFriendList'})}})
            })
            .catch((err) => {
              if (err.response.data.msg) {
                this[SHOW_MODAL]({msg: err.response.data.msg, okHandling: () => {}})
              } else {
                throw err
              }
            })
            .catch($showModalWithErrorMsg.bind(this))

        // 플친 등록
        } else {
          if (this.isValidPlusFriendId === undefined) {
            this[SHOW_MODAL]({msg: '톡채널 아이디 유효 검사를 해주세요.', okHandling: () => {}})
            return;
          }
          if (!this.isValidPlusFriendId) {
            this[SHOW_MODAL]({msg: '유효하지 않은 톡채널 아이디입니다.', okHandling: () => {}})
            return;
          }
          if (this.selectedGame === null) {
            this[SHOW_MODAL]({msg: '게임을 선택하세요.'})
            return;
          }
          if (this.isUseImage && this.pgmAdDto.plusFriendViewInfo.imgUrl === '') {
            this[SHOW_MODAL]({msg: '이미지를 등록하세요.'})
            return;
          }

          playGameService.createPlusFriends(this.pgmAdDto)
            .then((res) => {
              this[SHOW_MODAL]({msg: '등록이 완료되었습니다.', okHandling: () => {this.$router.push({name: 'plusFriendList'})}})
            })
            .catch((err) => {
              if (err.response.data.msg) {
                this[SHOW_MODAL]({msg: err.response.data.msg, okHandling: () => {}})
              } else {
                throw err
              }
            })
            .catch($showModalWithErrorMsg.bind(this))
        }
      },
      isValid () {
        if (('' + this.pgmAdDto.plusFriendViewInfo.plusFriendId) === ('' + 385787323)) {
          this.isValidPlusFriendId = true
          this[SHOW_MODAL]({msg: '유효한 톡채널 아이디입니다.', okHandling: () => {}})
          return
        }
        playGameService.isValidPlusFriendId(this.pgmAdDto.plusFriendViewInfo.plusFriendId)
          .then((res)=> {
            if (res.data.msg === 'true') {
              this.isValidPlusFriendId = true
              this[SHOW_MODAL]({msg: '유효한 톡채널 아이디입니다.', okHandling: () => {}})
            }
            else {
              this.isValidPlusFriendId = false
              this[SHOW_MODAL]({msg: '유효하지 않은 톡채널 아이디입니다.', okHandling: () => {}})
            }
          })
          .catch($showModalWithErrorMsg.bind(this))
      },
      calcCharacterByte: calcCharacterByte,
      acceptHandlingForDimensionLimit: acceptHandlingForDimensionLimit,
      ...mapMutations('ui', [SHOW_MODAL])
    }
  }
</script>
<style scoped>
  .vSelectWrapper {
    width: 600px;
  }
  .vSelectWrapper .dropdown-toggle:after {
    display: none !important;
  }
</style>
